import { CircularProgress, Drawer, Grid, makeStyles } from "@material-ui/core";
import { Add, ThumbDown, ThumbUp } from "@material-ui/icons";
import { useAccessControl, useAuth } from "@airborne/react-admin";
import keyBy from "lodash/keyBy";
import * as React from "react";
import { useState } from "react";
import { Button, Create, Datagrid, ListContextProvider, TextField, Toolbar, required, useNotify } from "react-admin";
import { Form } from "react-final-form";
import { useHistory } from "react-router-dom";
import CreatedByField from "../../../../../src/Components/ReferenceFields/CreatedBy/CreatedByField";
import UpdatedByField from "../../../../../src/Components/ReferenceFields/UpdatedBy/UpdatedByField";
import { SectionTitle } from "../../../../../src/Components/SectionTitle";
import { Separator } from "../../../../../src/Components/Separator";
import RequestServiceableRedeliveryRemark from "../../../../../src/Pages/RequestOrder/Components/RequestServiceableRedelivery/RequestServiceableRedeliveryRemark";
import { useAppDataProvider } from "../../../../../src/dataprovider";
import { CustomDateField } from "../../../../Components/CustomDateField";
import { CustomDatetime } from "../../../../Components/CustomDatetime";
import { RequestStatus } from "../../../../Enums/RequestStatus";
import { ModelState } from "../../Models/ModelStateEnum";
import { RequestRedeliveryPostModel, RequestRedeliveryPutModel } from "../../Models/RequestServiceableRedeliveryModel";
import { SourceRequestOrder } from "../Constant/Source";
import ServiceableRedeliveryStatusChip from "../Statu/ServiceableRedeliveryStatusChip";
const gridContainerProps: any = {
  container: true,
  direction: "row",
  item: true,
  xs: 12,
  spacing: 1,
  justify: "space-around",
  alignItems: "center",
};

const useStyles = makeStyles({
  toolbar: {
    flex: "auto",
    justifyContent: "center",
    backgroundColor: "white",
  },
  defaultToolbar: {
    flex: "auto",
    justifyContent: "center",
  },
});

const ServiceableRedeliveryCreate = props => {
  const [loading, setLoading] = useState(false);
  const requestId = props.requestId;
  const dataProvider = useAppDataProvider();
  const notify = useNotify();
  const history = useHistory();
  const classes = useStyles();

  const CreateRequestRedeliveryButtonClick = async e => {
    CreateRequestRedelivery(e);
  };

  const CreateRequestRedelivery = async e => {
    let requestServiceableRedeliveryCreateModel: RequestRedeliveryPostModel = new RequestRedeliveryPostModel();

    requestServiceableRedeliveryCreateModel.RequestId = requestId;
    requestServiceableRedeliveryCreateModel.RedeliveryDate = e.redeliveryDate;
    requestServiceableRedeliveryCreateModel.Status = RequestStatus.RequestRedeliveryOffered;

    dataProvider
      .postRequestServiceableRedelivery(requestServiceableRedeliveryCreateModel)
      .then(result => {
        props.finalCallBack();
        notify(`Record created`, "success", false, true);
        setLoading(false);
        history.push("/requestorders/" + requestId + "/4");
      })
      .catch(result => notify(`${result}`, "error", false, true))
      .finally(() => setLoading(false));
  };

  return (
    <Form
      onSubmit={CreateRequestRedeliveryButtonClick}
      render={({ handleSubmit, form, values }) => (
        <form>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12}>
              <Create {...props}>
                <>
                  <Grid {...gridContainerProps}>
                    <SectionTitle label="Serviceable Redelivery Info" />
                  </Grid>
                  <Separator />
                  <Grid {...gridContainerProps} justify="flex-start">
                    <Grid {...gridContainerProps}>
                      <Grid item xs={12} sm={5}>
                        <CustomDatetime
                          source="redeliveryDate"
                          label="Request Redelivery Date"
                          validate={required()}
                          fullWidth
                          showTime
                        />
                      </Grid>
                    </Grid>
                    <Separator />
                    <Toolbar {...props} placeholder="" classes={classes}>
                      <Button
                        label={loading ? "Request Redelivery is creating!" : "Request Servicealbe Redelivery"}
                        disabled={loading}
                        size="medium"
                        variant="contained"
                        color="primary"
                        onClick={handleSubmit}
                      >
                        {loading ? <CircularProgress size="2rem" color="secondary" /> : <Add />}
                      </Button>
                    </Toolbar>
                  </Grid>
                </>
              </Create>
            </Grid>
          </Grid>
        </form>
      )}
    />
  );
};

const ServiceableRedeliveryView = props => {
  const redeliveryList = [] as any;
  redeliveryList.push(props.requestServiceableRedelivery);

  return (
    <>
      <ListContextProvider
        value={{
          data: keyBy(redeliveryList, "id"),
          ids: redeliveryList.map(({ id }) => id),
          currentSort: { field: "id", order: "ASC" },
        }}
      >
        <ServiceableRedeliveryStatusChip requestRedelivery={props.requestServiceableRedelivery} />
        <Datagrid>
          <CustomDateField label="Request Delivery Date" source="redeliveryDate" />
          <TextField label="Request Redelivery Remark" source="redeliveryRemark" />
          <CreatedByField label="CREATED BY" link={false} />
          <CustomDateField source="createdDate" label="CREATED DATE" />
          <UpdatedByField label="Updated By" link={false} />
          <CustomDateField source="updatedDate" label="UPDATED DATE" />
        </Datagrid>
      </ListContextProvider>
    </>
  );
};

const ServiceableRedeliveryEdit = props => {
  const [loading, setLoading] = useState(false);
  const [isDrawerShown, setIsDrawerShown] = useState(false);
  const history = useHistory();
  const notify = useNotify();
  const dataProvider = useAppDataProvider();
  const { user } = useAuth();
  const { canPerform: canEditOnlyShow } = useAccessControl(SourceRequestOrder, "editonlyshow");
  const requestId = props.requestId;

  const handleClose = () => {
    setIsDrawerShown(false);
  };

  const AcceptOrRejectButtonClick = isApproved => e => {
    if (isApproved === true) {
      AcceptOrRejectServiceableRedelivery(isApproved);
    } else {
      setIsDrawerShown(true);
    }
  };

  const AcceptOrRejectServiceableRedelivery = isApproved => {
    let requestServiceableRedeliveryUpdateModel: RequestRedeliveryPutModel = new RequestRedeliveryPutModel();

    requestServiceableRedeliveryUpdateModel.id = props.requestServiceableRedelivery[0].id;
    requestServiceableRedeliveryUpdateModel.RequestId = props.requestServiceableRedelivery[0].requestId;
    requestServiceableRedeliveryUpdateModel.RedeliveryDate = props.requestServiceableRedelivery[0].redeliveryDate;
    requestServiceableRedeliveryUpdateModel.Status =
      isApproved === true ? RequestStatus.RequestRedeliveryAccepted : RequestStatus.RequestRedeliveryRejected;

    requestServiceableRedeliveryUpdateModel.updatedBy = user?.employeeId;
    requestServiceableRedeliveryUpdateModel.updatedDate = new Date();

    dataProvider
      .putRequestServiceableRedelivery(requestServiceableRedeliveryUpdateModel)
      .then(result => {
        props.finalCallBack();
        notify(`Record Updated`, "success", false, true);
        history.push("/requestorders/" + requestId + "/4");
      })
      .catch(result => notify(`${result}`, "error", false, true))
      .finally(() => setLoading(false));
  };

  const useStyles = makeStyles({
    toolbar: {
      display: "flex",
      justifyContent: "start",
      backgroundColor: "white",
    },
    defaultToolbar: {
      display: "flex",
      justifyContent: "start",
    },
  });
  const classes = useStyles();

  const redeliveryList = [] as any;
  redeliveryList.push(props.requestServiceableRedelivery);

  return (
    <>
      <ListContextProvider
        value={{
          data: keyBy(redeliveryList, "id"),
          ids: redeliveryList.map(({ id }) => id),
          currentSort: { field: "id", order: "ASC" },
        }}
      >
        <ServiceableRedeliveryStatusChip requestRedelivery={props.requestServiceableRedelivery} />
        <Datagrid>
          <CustomDateField label="Request Delivery Date" source="redeliveryDate" />
          <TextField label="Request Redelivery Remark" source="redeliveryRemark" />
          <CreatedByField label="CREATED BY" link={false} />
          <CustomDateField source="createdDate" label="CREATED DATE" />
          <UpdatedByField label="Updated By" link={false} />
          <CustomDateField source="updatedDate" label="UPDATED DATE" />
        </Datagrid>
      </ListContextProvider>
      {canEditOnlyShow && (
        <Toolbar {...props} placeholder="" classes={classes}>
          <Button
            label={loading ? "Request Redelivery is Accepted!" : "Accept Request Redelivery"}
            size="medium"
            variant="contained"
            style={{ background: "seagreen" }}
            onClick={AcceptOrRejectButtonClick(true)}
          >
            {loading ? <CircularProgress size="2rem" color="secondary" /> : <ThumbUp />}
          </Button>
          <Button
            style={{ margin: "8px" }}
            label={loading ? "Request Redelivery is Rejected!" : "Reject Request Redelivery"}
            size="medium"
            variant="contained"
            color="primary"
            onClick={AcceptOrRejectButtonClick(false)}
          >
            {loading ? <CircularProgress size="2rem" color="secondary" /> : <ThumbDown />}
          </Button>

          <Drawer variant="persistent" open={isDrawerShown} anchor="right" onClose={handleClose}>
            <RequestServiceableRedeliveryRemark
              requestServiceableRedelivery={props.requestServiceableRedelivery}
              finalCallBack={props.finalCallBack}
              onClose={handleClose}
              resource="/requestredeliverys"
              basePath=""
            />
          </Drawer>
        </Toolbar>
      )}
    </>
  );
};
const RequestServiceableRedelivery = props => {
  switch (props.ModelState) {
    case ModelState.Create:
      return (
        <ServiceableRedeliveryCreate
          resource="/requestredeliverys"
          basePath=""
          requestId={props.requestId}
          requestServiceableRedelivery={props.requestServiceableRedelivery}
          requestdetail={props.requestDetailData}
          finalCallBack={e => props.parentCallBack()}
        />
      );

    case ModelState.Edit:
      return (
        <ServiceableRedeliveryEdit
          requestServiceableRedelivery={props.requestServiceableRedelivery}
          requestdetail={props.requestDetailData}
          requestId={props.requestId}
          finalCallBack={e => props.parentCallBack()}
        />
      );

    default:
      return (
        <ServiceableRedeliveryView
          requestServiceableRedelivery={props.requestServiceableRedelivery}
          requestdetail={props.requestDetailData}
          requestId={props.requestId}
          finalCallBack={e => props.parentCallBack()}
        />
      );
  }
};

export default RequestServiceableRedelivery;
